import Model from '@/lib/data/Model';
import FileTag from './FileTag';

class VisitDocument extends Model {
    static idProperty = 'id';

    fields = [
        'id',
        'visit_id',
        'file_storage_id',
        'mime_type',
        'name',
        'size',
        'base64',
        'created_by',
        'created_by_name',
        {
            name: 'tags',
            association: {
                type: 'many',
                model: FileTag,
            },
        },
    ];

    constructor(data) {
        super(data);
        this.init();
    }

    api = [
        {
            name: 'remove',
            url: '/mobile/visit/file/delete',
            params: ['ids'],
        },
    ];
}

export default VisitDocument;
